<template>
    <div class="home">
      <div class="container">
        <div class="columns is-centered">
          <div class="column">
            <ValidationObserver v-slot="{ errors }" tag="div">
            <input-form
              ref="form"
              :errors="errors"
              name="RFPProjectInformation"
              @submit.prevent="onFileUpload"
            >
              <div class="content">
                <h1>Project Information</h1>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                      v-model="FullSummaryApplication.ProjectName"
                      error="This field is required"
                      name="input-project-name"
                      required
                      rules="required"
                      placeholder="Project Name"
                      type="text"/>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-dropdown
                      v-model="FullSummaryApplication.ProposalType"
                      name="input-proposal-type"
                      :options="proposalTypes"
                      required
                      rules="required"
                      error="This field is required"
                      placeholder="Proposal Type"
                      type="text"/>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                      v-model="FullSummaryApplication.NumberOfUnits"
                      error="This field is required"
                      name="input-number-of-units"
                      required
                      rules="required"
                      placeholder="Total Number Of Units"
                      type="number"/>
                  </div>
                  <div class="column">
                    <vee-textbox
                      v-model="FullSummaryApplication.FundingRequested"
                      error="This field is required"
                      name="input-funding-requested"
                      required
                      rules="required"
                      placeholder="DHCD/PHDC Funding Amount Requested"
                      type="number"/>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                      v-model="FullSummaryApplication.TotalDevelopmentCost"
                      error="This field is required"
                      name="input-total-development-cost"
                      required
                      rules="required"
                      placeholder="Total Development Cost"
                      type="number"/>
                  </div>
                  <div class="column">
                    <vee-textbox
                      v-model="FullSummaryApplication.TotalConstructionCost"
                      error="This field is required"
                      name="input-total-construction-cost"
                      required
                      rules="required"
                      placeholder="Total Construction Cost"
                      type="number"/>
                  </div>
                </div>
                <h2>Cost per Square Foot Calculations</h2>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                      v-model="FullSummaryApplication.SquareFootage"
                      error="This field is required"
                      name="input-square-footage"
                      required
                      rules="required"
                      placeholder="Square Footage"
                      type="number"/>
                  </div>
                  <div class="column">
                    <vee-textbox
                      v-model="DevelopmentCostPerSquareFoot"
                      error="This field is required"
                      name="input-development-cost-per-square-foot"
                      readonly
                      :disabled="true"
                      placeholder="Development Cost/SqFt"
                      type="number"/>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                      v-model="ConstructionCostPerSquareFoot"
                      error="This field is required"
                      name="input-construction-cost-per-square-foot"
                      readonly
                      :disabled="true"
                      placeholder="Construct Cost/SqFt"
                      type="number"/>
                  </div>
                  <div class="column">
                    <vee-textbox
                      v-model="SubsidyPerUnit"
                      error="This field is required"
                      name="input-subsidy-per-unit"
                      readonly
                      :disabled="true"
                      placeholder="Subsidy Request Per Unit"
                      type="number"/>
                  </div>
                </div>
                <h2>Development Details</h2>
                <div class="columns">
                  <div class="column">
                    <vee-dropdown
                      v-model="FullSummaryApplication.DevelopmentCategory"
                      name="input-development-category"
                      :options="developmentTypes"
                      required
                      rules="required"
                      error="This field is required"
                      placeholder="Development Category"
                      @change="onNo"
                      type="text"/>
                  </div>
                  <div class="column">
                    <vee-dropdown
                      v-model="FullSummaryApplication.DevelopmentCategory2"
                      name="input-development-category2"
                      :options="developmentTypes"
                      error="This field is required"
                      placeholder="Second Development Category (If applicable)"
                      type="text"/>
                  </div>
                  <div v-if="FullSummaryApplication.DevelopmentCategory == 'Preservation (occupied)'" class="column">
                    <vee-textbox
                      v-model="FullSummaryApplication.ExpirationYear"
                      name="input-expiration-year"
                      rules="year:1900,2100"
                      error="This field is required"
                      placeholder="Expiration Year of Existing Affordability Restrictions"
                      type="number"/>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-checkbox
                      v-model="FullSummaryApplication.PopulationServed"
                      name="input-population-served"
                      :options="populationServed"
                      required
                      rules="required"
                      error="This field is required"
                      label="Population Served"
                      numOfColumns="4"
                      type="text"/>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                      <vee-textarea
                        v-model="FullSummaryApplication.PopulationServedDescription"
                        error="This field is required"
                        name="input-population-served-description"
                        required
                        rules="required"
                        placeholder="Population Served Description"
                        type="text"
                        />
                    </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-dropdown
                      v-model="FullSummaryApplication.ServicesOffered"
                      name="input-services-offered"
                      :options="yesNo"
                      required
                      rules="required"
                      error="This field is required"
                      placeholder="On-site Services Offered"
                      @change="onNo"
                      type="text"/>
                  </div>
                </div>
                <div v-if="FullSummaryApplication.ServicesOffered == 'Yes'" class="columns">
                  <div class="column">
                      <vee-textarea
                        v-model="FullSummaryApplication.ServicesOfferedDescription"
                        error="This field is required"
                        name="input-services-offered-description"
                        required
                        rules="required"
                        placeholder="On-site Services Offered Description"
                        type="text"
                        />
                    </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-dropdown
                      v-model="FullSummaryApplication.MixedUse"
                      name="input-mixed-use"
                      :options="yesNo"
                      required
                      rules="required"
                      error="This field is required"
                      @change="onNo"
                      placeholder="Mixed-Use"
                      type="text"/>
                  </div>
                </div>
                <div class="columns">
                  <div v-if="FullSummaryApplication.MixedUse == 'Yes'" class="column">
                    <vee-textbox
                      v-model="FullSummaryApplication.CommercialTenant"
                      error="This field is required"
                      name="input-commercial-tenant"
                      required
                      rules="required"
                      placeholder="Commercial Tenant"
                      type="text"/>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-dropdown
                      v-model="FullSummaryApplication.MixedIncomeHousingBonus"
                      :options="yesNo"
                      error="This field is required"
                      name="input-mixed-income-housing-bonus"
                      required
                      rules="required"
                      placeholder="Mixed Income Housing Bonus"
                      type="text"/>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-checkbox
                      v-model="FullSummaryApplication.Attributes"
                      :options="projectAttributes"
                      error="This field is required"
                      name="input-project-location-attributes"
                      placeholder="Project/Location Attributes"
                      label="Project/Location Attributes (If applicable)"
                      @input="onNo"
                      type="text"/>
                  </div>
                  <div v-if="FullSummaryApplication.Attributes.includes('Place-Based Strategy Area')" class="column">
                    <vee-checkbox
                      v-model="FullSummaryApplication.StrategyArea"
                      :options="strategyArea"
                      error="This field is required"
                      name="input-strategy-area"
                      required
                      rules="required"
                      placeholder="Strategy Area"
                      label="Strategy Area"
                      type="text"/>
                  </div>
                </div>
                <h2>Proposal Narrative</h2>
                <div class="columns">
                  <div class="column">
                    <vee-textarea
                      v-model="FullSummaryApplication.ProjectDescription"
                      error="This field is required"
                      name="input-project-description"
                      required
                      rules="required"
                      placeholder="Project Summary"
                      type="text"/>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-textarea
                      v-model="FullSummaryApplication.AdditionalFeatures"
                      error="This field is required"
                      name="input-additional-features"
                      required
                      rules="required"
                      placeholder="Project Description"
                      type="text"/>
                  </div>
                </div>
                <div class="columns">
                  <div class="column" style="text-align: left;">
                      <button
                      type="button"
                      class="button is-primary"
                      @click="prevPage"
                      >
                      Back
                      </button>
                  </div>
                  <div class="column" style="text-align: right;">
                      <button
                      type="button"
                      class="button is-primary"
                      @click="nextPage"
                      >
                      Next
                      </button>
                  </div>
              </div>
              </div>
            </input-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import { getPropertyValueOrDefault } from "@/utilities/functions.js";
// import buildPropertyInfoObject from "@/utilities/get-property-info-object.js";
// import axios from "axios";
import options from "@/utilities/options";

export default {
  name: 'RFPProjectInformation',
  mixins: [options],
  data() {
    return {
      FullSummaryApplication: null,
    };
  },
  async beforeMount(){
    window.scrollTo(0, 0);
    this.FullSummaryApplication = await this.$vlf.getItem('fullSummaryApplication');
  },
  computed:{
    DevelopmentCostPerSquareFoot: function(){
      return (this.FullSummaryApplication.TotalDevelopmentCost/this.FullSummaryApplication.SquareFootage).toFixed(0);
    },
    ConstructionCostPerSquareFoot: function(){
      return (this.FullSummaryApplication.TotalConstructionCost/this.FullSummaryApplication.SquareFootage).toFixed(0);
    },
    SubsidyPerUnit: function(){
      return (this.FullSummaryApplication.FundingRequested/this.FullSummaryApplication.NumberOfUnits).toFixed(0);
    },
  },
  methods: {
    onNo(){
      if(this.FullSummaryApplication.ServicesOffered == 'No'){
        this.FullSummaryApplication.ServicesOfferedDescription = null;
      }
      if(this.FullSummaryApplication.MixedUse == 'No'){
        this.FullSummaryApplication.CommercialTenant = null;
      }
      if(!this.FullSummaryApplication.Attributes.includes("Place-Based Strategy Area")){
        this.FullSummaryApplication.StrategyArea = [];
      }
      if(this.FullSummaryApplication.DevelopmentCategory != 'Preservation (occupied)'){
        this.FullSummaryApplication.ExpirationYear = null;
      }
    },
    async nextPage(){
      this.FullSummaryApplication.DevelopmentCostPerSquareFoot = this.DevelopmentCostPerSquareFoot;
      this.FullSummaryApplication.ConstructionCostPerSquareFoot = this.ConstructionCostPerSquareFoot;
      this.FullSummaryApplication.SubsidyPerUnit = this.SubsidyPerUnit;
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "ProjectTeam",
            });
        }
    },
    async prevPage(){
      this.FullSummaryApplication.DevelopmentCostPerSquareFoot = this.TotalDevelopmentCost/this.SquareFootage;
      this.FullSummaryApplication.ConstructionCostPerSquareFoot = this.TotalConstructionCost/this.SquareFootage;
      this.FullSummaryApplication.SubsidyPerUnit = this.FundingRequested/this.NumberOfUnits;
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            this.$vlf.removeItem('fullSummaryApplication');
            await this.$vlf.setItem('fullSummaryApplication', this.FullSummaryApplication);
            
            this.$router.push({
                name: "ProjectSummaryForm",
            });
        }
    },
  }
};
</script>